// src/hooks/useMessageHandler.js
import {useDispatch, useSelector} from 'react-redux';
import {
    messagesNewMessage,
    messageUnreadMessage,
    messageAppendOffsetByMessageId,
    messageAddFirstContactMessages,
    messageUpdateById,
} from '../actions/messages';
import {contactUpdate, setSavedContactDetails} from "../actions/contacts/contacts";

export const useMessageHandler = (
    {
        refContactDetails,
        refSelectContactMessages,
        refContactMessages,
        refSavedContactDetails,
        refIdMyAgent,
        instance,
        tokenRequest,
        source,
    }
) => {
    const dispatch = useDispatch();
    const selectedContactId = useSelector(
        state => state.contact.contactDetails?._id
    );
    // Retorna el mensaje optimista local que corresponde al mensaje del socket,
    // o null si no es un duplicado.
    const findOptimisticDuplicate = (message) => {
        const currentMessages = refSelectContactMessages.current?.messages || [];

        // Check 1: portalId match (mensaje enviado desde esta sesión)
        const portalId = message?.meta_data?.portalId;
        if (portalId) {
            return currentMessages.find(m => m?.meta_data?.portalId === portalId) ?? null;
        }

        // Check 2: el socket devuelve el mensaje del agente con id_gupshup,
        // pero el mensaje optimista en el store no lo tiene aún.
        if (message?.id_gupshup && message?.body) {
            return currentMessages.find(
                m => !m?.id_gupshup && m?.body === message.body
            ) ?? null;
        }

        return null;
    };

    const isDuplicate = (message) => findOptimisticDuplicate(message) !== null;

    const isCurrentContactSelected = (message) => {
        return (
            selectedContactId === message.id_contact ||
            refContactDetails.current?._id === message.id_contact
        );
    };


    const handleMessageActions = (contact, message) => {
        console.log("message", message)
        console.log("isCurrentContactSelected", isCurrentContactSelected(message))
        console.log("!isDuplicate(message)", !isDuplicate(message))

        const optimistic = findOptimisticDuplicate(message);
        if (optimistic) {
            // Actualiza el mensaje optimista con los datos reales del servidor
            dispatch(messageUpdateById(optimistic._id, {
                _id: message.id ?? optimistic._id,
                id: message.id,
                id_gupshup: message.id_gupshup,
                meta_data: message.meta_data ?? optimistic.meta_data,
            }));
            dispatch(contactUpdate({contact, loading: false}));
            dispatch(setSavedContactDetails(contact));
            return;
        }

        if (isCurrentContactSelected(message)) {
            if (Object.keys(refSelectContactMessages.current).length !== 0) {
                if (message.id_contact === refContactDetails.current._id) {

                    let contactMessages = refContactMessages.current.find(
                        (msg) => msg.id_contact === message.id_contact
                    );

                    if (!contactMessages) {
                        contactMessages = refSelectContactMessages.current;
                        dispatch(messageAddFirstContactMessages(contactMessages));
                    }

                    if (contactMessages) {
                        if (contact.unread_message === 0 && message.incoming) {
                            dispatch(messageUnreadMessage(contact._id));
                        }

                        message._id = message.id;

                        const messageExists =
                            contactMessages.messages?.some(
                                (msg) => msg._id === message._id || msg.id === message._id
                            );

                        if (messageExists) return;

                        dispatch(
                            messageAppendOffsetByMessageId(message.id_contact, message._id)
                        );
                        dispatch(messagesNewMessage(message));
                    }
                }
            }

            dispatch(contactUpdate({contact, loading: false}));
            dispatch(setSavedContactDetails(contact));
        }
    };

    return {
        isDuplicate,
        handleMessageActions,
        isCurrentContactSelected,

    };
};
